module.exports = __webpack_public_path__ + "img/pangao_user_active_bg.f945e574.png";